import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormView } from "@form/cer-form-view";

export class DataTagForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {

    const view = this.viewGet();
    viewSet.viewAdd(view);
  }

  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'kategorier', dataApiName: 'DataTag', text: 'Kategorier', textSingular: 'Kategori',
      primaryKey: 'id', baseFields: ['id', 'history']
    };

    view.fieldMetadata = [
      { fieldType: 'dataTable', required: true },
      { name: 'row', text: 'Række', required: true },
      { fieldType: 'dataTagType', required: true}
    ];

    return view;
  }
}
